export enum PERMISSIONS {
  CAN_VIEW_ADMIN_REPORT = "CN{PRODUCT_TYPE}_RPT_ADM_PROD",
  CAN_CANCEL_CN = "CN{PRODUCT_TYPE}_OPT_CANCEL",
  CAN_CANCEL_PROPOSAL = "PO{PRODUCT_TYPE}_OPT_CANCEL",
  CAN_CANCEL_DRAFT = "CN$PRODUCT_TYPE_CANCEL_DRAFT",
  CAN_APPORVE_CANCEL_CN = "CN{PRODUCT_TYPE}_CANC_APPR",
  CAN_APPROVE_PENDING_CN = "CN{PRODUCT_TYPE}_REFER_APPR",
  CAN_DOWNLOAD_CANCEL_LETTER = "CN{PRODUCT_TYPE}_PDF_CANC_LTR",
  CAN_DOWNLOAD_CN = "CN{PRODUCT_TYPE}_PDF_CN",
  CAN_DOWNLOAD_PROPOSAL = "CN{PRODUCT_TYPE}_PDF_PROPOSAL",
  CAN_VIEW_AGENT_REPORT = "CN{PRODUCT_TYPE}_RPT_AGN_PROD",
  //add constant here
  CAN_UPDATE_QUOTATION_BUTTON = "PO$PRODUCT_TYPE_OPT_UPD",
  CAN_UPDATE_PROPOSAL = "PO{PRODUCT_TYPE}_OPT_UPD",
  CAN_ISSUE_SCHEDULE = "CN{PRODUCT_TYPE}_NOTE_CN",
  CAN_ISSUE_AHI = "CNAHI_NOTE_CN",
  //MenuAccess Product Type Prefix
  MENU_PRODUCT_TYPE_PREFIX = "{PRODUCT_TYPE}",
  //add constant here
  //CAN_UPDATE_QUOTATION_BUTTON = 'POABS_OPT_UPD',
  //CAN_UPDATE_PROPOSAL_BUTTON = 'POAHI_OPT_UPD',
}

export enum ECNCNOTETYPE {
  NW = "New",
  RN = "Renewal",
  ENDT = "Endorsement",
}

export enum USERROLE {
  AGENT = "agent",
  ADMIN = "admin",
  BRANCH = "branchAdmin",
  BANCA = "bancaAgent",
}

export enum USERROLEINTEXT {
  agent = "Agent",
  callCenter = "Call Center",
  admin = "Admin",
}

export enum CLIENTTYPE {
  INDIVIDUAL = "P",
  COMPANY = "I",
  P = "Individual",
  I = "Company",
}

export enum GENDER {
  MALE = "M",
  FEMALE = "F",
  M = "Male",
  F = "Female",
}

export enum MARITALSTATUS {
  SINGLE = "0",
  MARRIED = "1",
  DIVORCE = "2",
}

export enum CLIENTADDRESSTYPE {
  RESIDENTIAL = "R",
  NON_RESIDENTAIL = "O",
}

export enum IDTYPE {
  NRIC = "NRIC",
  OLD_IC = "OLD_IC",
  PASS = "PASS",
  POL = "POL",
  BR_NO_NEW = "NEW_BR_NO",
  BR_NO_OLD = "BR_NO",
}

export enum COUNTRIES {
  MALAYSIAN = "MAL",
  NON_MALAYSIAN = "NM",
  MAL = "Malaysia",
  NM = "Non Malaysian",
}

export enum ECNSTATUS {
  "SAVED" = "3",
  "PRINTED" = "0",
  "CANCELLED" = "4",
  "PENDING" = "1",
  "P.CANCEL" = "2",
}

export enum CNAMCSTATUS {
  "PCANCEL" = "P.CANCEL",
}

export const COMBINEDNAMEROLE = {
  O: "OWNER",
  D: "DECEASED",
  A: "ADMINISTRATOR",
  M: "MORTGAGOR",
  L: "LESSOR",
  C: "CHARGOR",
  H: "HOLDING COMPANY",
  S1: "SECURITY AGENT",
  S2: "SUBSIDIARY COMPANY",
  P1: "PARENT COMPANY",
  P2: "PROPERTY MANAGEMENT COMPANY",
  B: "BORROWER",
  D1: "DECEASED",
  D2: "DEVELOPER",
  AI: "ADDITIONAL INSURED",
  P3: "PROPERTY MANAGEMENT COMPANY",
  P4: "PRINCIPAL",
} as const;

export enum MORTGAGETYPE {
  D = "DEBENTURE HOLDER",
  M = "MORTGAGEE",
  L = "LESSEE",
  C = "CHARGEE",
  H = "HIRER",
}

export const PRODUCTTYPE = {
  ABS: "ABS",
  AHI: "AHI",
  AMC: "AMC",
  ALP: "ALP",
  PA4A: "PA4A",
  EQUOTE: "EQUOTE",
  AS: "AS",
  FI: "FI",
  TC: "TC",
  ASPA: "ASPA",
  ATX: "ATX",
  MT: "MT",
  ADHS: "ADHS",
} as const;

export enum PRODUCT_CODE {
  "040100" = "FIRE",
  "040200" = "FIRE CONSEQUENTIAL LOSS",
  "040800" = "COMMERCIAL FIRE",
  "050201" = "PUBLIC LIABILITY (PREMISES)",
  "010401" = "BURGLARY",
  "010701" = "MONEY",
  "010201" = "All RISKS",
  "050702" = "COMPREHENSIVE GENERAL LIABILITY (FAC)",
  "013701" = "MISC COMBO",
  "050101" = "PRODUCT LIABILITY",
  "050601" = "DIRECTORS AND OFFICERS LIABILITY",
  "090601" = "EMPLOYER'S LIABILITY",
}

export enum PRODUCT_TYPE_TITLE {
  AMC = "Allianz MediCure",
  ABS = "Allianz Business Shield",
  AHI = "Allianz Hospital Income",
  PA4A = "PerlindunganKu Allianz4All",
}

export const PRODUCT_TYPE_INFO = {
  AMC: "Extended Info",
  ABS: "Additional Info",
  AHI: "Additional Info",
  PA4A: "Extended Info",
} as const;

export enum SPECIFIEDTYPE {
  SPECIFIED = "SPECIFIED",
  UNSPECIFIED = "UNSPECIFIED",
  CUSTOMER = "CUSTOMER",
}
export enum FILTEREDSEARCHBY {
  EQUOTATION_NO = "proposalNo",
  ESCHEDULE_NO = "cnoteNo",
}
export enum RENEWALIDTYPE {
  NRIC = "nric",
  NEW_BR_NO = "newBusReg",
  CNAME = "clientName",
  OTHER = "other",
  POL = "policyNo",
  BR_NO = "busReg",
}

export enum PAGES {
  ESCHEDULE_BASE_PATH = "/new-e-schedule/",
  SELECT_AGENT_CODE = "SELECT_AGENT_CODE",
  DECLARATION_AND_TYPE = "DECLARATION_AND_TYPE",
  CUSTOMER_INFO = "CUSTOMER_INFO",
  SITUATION_OF_RISK = "SITUATION_OF_RISK",
  COVERAGE_DETAILS = "COVERAGE_DETAILS",
  ADDITIONAL_INFO = "ADDITIONAL_INFO",
  EXTENDED_INFORMATION = "EXTENDED_INFORMATION",
  SUMMARY = "SUMMARY",
  COMPLETE = "COMPLETE",
  AHI_EQUOTE_DETAILS = "AHI_EQUOTE_DETAILS",
  AHI_EQUOTE_SUMMARY = "AHI_EQUOTE_SUMMARY",
  PRINCIPAL_DETAILS = "PRINCIPAL_DETAILS",
  APPLICATION_METHOD = "APPLICATION_METHOD",
}

export enum ACTIONS {
  VIEW = "VIEW",
  UPDATE = "UPDATE",
  ISSUE = "ISSUE",
  ISSUE_REPROPOSAL = "ISSUE-REPROPOSAL",
  PROFILE = "PROFILE",
  SUMMARY = "SUMMARY",
  ENQUIRY = "ENQUIRY",
  REPORTS = "REPORTS",
  SUMMARY_DRAFT = "SUMMARY-DRAFT",
  SUMMARY_APPROVAL = "SUMMARY-APPROVAL",
  NOTIFICATION = "NOTIFICATION",
  REQUOTE = "REQUOTE",
  CI = "CI",
  MOTOR_APPROVAL = "MT-APPROVAL",
  VIEWPOLICY = "VIEWPOLICY",
  CLAIMPOLICY = "CLAIMPOLICY",
  VIEWENDT = "VIEWENDT",
  SUMMARY_EXPIRINGSOON = "SUMMARY-EXPIRINGSOON",
}

export enum EQUOTETYPE {
  NW = "New",
  RN = "Renewal",
  ENDT = "Endorsement",
}

export enum OCCCUSTOMERTYPE {
  BA = "BA",
  FR = "FR",
}

export enum REGEX {
  EMAIL = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,63}$",
  TIN_NO = "^[a-zA-Z0-9]{1,13}$",
}

export enum SUBOCCUPATIONCODELEVEL {
  HIGH = "H",
  MEDIUM = "M",
  LOW = "L",
}

export enum OCCUPATIONCLASSIFICATION {
  GENERAL_MERCHANDISE = "1102",
  GENERAL_STORAGE = "3402",
  RETAIL = "1106",
}

export enum INTERESTINSUREDCODE {
  ON_STOCK = "S",
}

export enum COVERAGETYPE {
  AN = "ANNUAL",
  MY = "MULTIYEAR",
  OW = "ONE WAY",
  TW = "TWO WAY",
  "2Y" = "TWO YEARS",
}

export const CONSTANTS = {
  DEFAULT_DISPLAY: "N/A",
  CODE: "code",
  NAME: "name",
  DDMMYY: "DD/MM/YYYY",
  DDMMYYYYTime: "DD/MM/YYYY h:mm a",
  YYMMDD: "YYMMDD",
  YYYYMMDD: "YYYY-MM-DD",
  YYYYMMDDTIME: "YYYY-MM-DD HH:mm:ss",
  DDMMYYYY: "DD-MM-YYYY",
  FUTURE_FEATURE: "This will be implemented in the next release.",
  STATUS_200: "200",
  STATUS_NOT_200: "500",
  AMC_PRINCIPAL: "P",
  AMC_DEPENDANT: "D",
  PERSON: "PERSON",
  AMC_COMPANY: "COMPANY",
  CLIENT_TYPE_INDUSTRY: "I",
  CLIENT_TYPE_INDIVIDUAL: "P",
  ISSUANCE_TYPE_NEW: "NW",
  ISSUANCE_TYPE_RENEWAL: "RN",
  DOS_COVER_DEFAULT_TIME_EXCESS: "8",
  DOS_COVER_DEFAULT_TIME_EXCESS_TYPE: "H",

  getCNType() {
    return (key: any) => ECNCNOTETYPE[key];
  },

  getEquoteType() {
    return (key: any) => EQUOTETYPE[key];
  },

  getRoleName() {
    return (key: any) => USERROLEINTEXT[key];
  },

  getClientType() {
    return (key: any) => CLIENTTYPE[key];
  },

  getCountry() {
    return (key: any) => COUNTRIES[key];
  },

  getMaritalStatus() {
    const STATUSES = {
      0: "Single",
      1: "Married",
      2: "Divorce",
    };
    return (code) => STATUSES[code];
  },

  getGender() {
    return (key: any) => GENDER[key];
  },

  getIdType() {
    return (key: any) => IDTYPE[key];
  },

  getProduct() {
    return (key: any) => PRODUCT_CODE[key];
  },

  getIdLabel() {
    const IDLABEL = {
      NRIC: "NRIC",
      OLD_IC: "Old IC No.",
      PASS: "Passport No.",
      POL: "Police/Army ID",
      NEW_BR_NO: "New Business Registration No.",
      BR_NO: "Business Registration No.",
    };
    return (key) => IDLABEL[key];
  },

  getConsentStatus() {
    const CONSTENTSTATUS = {
      Yes: true,
      No: false,
    };
    return (key) => CONSTENTSTATUS[key];
  },

  getStatus() {
    const STATUS = {
      true: "Yes",
      false: "No",
    };
    return (key) => STATUS[key];
  },

  getCNStatusCode() {
    return (key: any) => ECNSTATUS[key];
  },

  getRiskLocated() {
    const RISKLOCATED = {
      WM: "Within Malaysia - Non Designated",
      OM: "Outside Malaysia",
      DA: "Designated Area (Langkawi, Labuan and Tioman)",
    };
    return (key) => RISKLOCATED[key];
  },

  getConstructionWallList() {
    const CONSTRUCTIONWALLLIST = {
      COW1: "Fully brick walls and/or 2 hours fire resistance",
      COW2: "Partly brick walls and partly of non-combustible material and/or wholly of glass",
      COW3: "Partly brick/wood walls or other combustible material not exceeding 50% of total wall area",
      COW4: "Partly brick/wood walls or other combustible material exceeding 50% of total wall area",
    };
    return (key) => CONSTRUCTIONWALLLIST[key];
  },

  getConstructionRoofList() {
    const CONSTRUCTIONROOTLIST = {
      COR1: "Non-combustible material",
      COR2: "Combustible material",
    };
    return (key) => CONSTRUCTIONROOTLIST[key];
  },

  getInterestInsured() {
    const INTERESTINSURED = {
      "01": "COMMERCIAL FIRE: FIRE",
    };
    return INTERESTINSURED;
  },

  getProdctTitle() {
    return (key: any) => PRODUCT_TYPE_TITLE[key];
  },

  getInfoType() {
    return (key: any) => PRODUCT_TYPE_INFO[key];
  },

  getCoverageType() {
    return (key: any) => COVERAGETYPE[key];
  },

  getMotorCNType() {
    return (key: any) => MOTORCNTYPE[key];
  },
} as const;

export class FixedArray {
  public static getReportList() {
    return {
      accumulationReportList: ["CNEQUOTE_RPT_ACC_LST", "CNABS_RPT_ACC_LST"],
    };
  }
}

export const UW_FACTORS_LOV = [
  { code: "F", descp: "Favourable" },
  { code: "U", descp: "Unfavourable" },
  { code: "NA", descp: "Not Applicable" },
];

export const FLOOD_HAZARD_LOV = [
  ...UW_FACTORS_LOV,
  { code: "FP", descp: "Flood Prone" },
  { code: "NFP", descp: "Non Flood Prone" },
];

export enum CRITERIA_LOV {
  CUSTOMER_NAME = "clientName",
  AGENT_CODE = "agentCode",
  AGENT_NAME = "agentName",
  EPROPOSAL = "quotationNo",
  ESCHEDULE = "cnoteNo",
  NRIC = "nric",
  ID = "other",
  BUSSINESS_REG = "busReg",
  NEW_BUSINESS_REG = "newBusReg",
  VOUCHER_NO = "voucherNo",
  SUPERIOR_CODE = "superiorCode",
}

export const CLAIM_HISTORY_IND = {
  TRUE: "1",
  FALSE: "0",
};

export enum PROPOSAL_TYPE {
  PROPOSAL = "P",
  QUOTATION = "Q",
}

export enum CNOTESTATUS {
  SAVED = "SAVED",
  PENDING = "PENDING",
  PRINTED = "PRINTED",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
  PENDING_CANCELLATION = "P.CANCEL",
  EXPIRED = "EXPIRED",
}

export enum LOADINGCODES {
  ICD_LOADING = "ICD",
  INPATIENTCLAIMS_LOADING = "CLMINP",
  AGE_LOADING = "AGE",
  CLAIMS_LOADING = "CLMLD",
}

export enum SUB_CHANNELS {
  HSBC = "1-16",
}

export enum MOTORCNTYPE {
  NWNN = "New Business - New Vehicle, New Registration",
  NWOO = "New Business - Old Vehicle, Old Registration",
  RN = "Renewal",
  NWTR = "New Business - Transfer of Ownership",
  COE = "Change of Engine",
  RP = "Road Tax Purpose",
  XP = "Extension Prorate",
  XS = "Extension Short Period",
  OTTEMP = "Others - Temporary Permit (Excursion Trip)",
  ENDT04 = "Amendment of Period",
  ENDT05 = "Cancellation by Insured",
  ENDT09 = "Change of Bancassurance Details",
  ENDT10 = "Change of Vehicle Chassis No",
  ENDT12 = "Change of Vehicle Registration No",
  ENDT17 = "Extra Benefits",
  ENDT18 = "Hire Purchase/Employers' Loan/Leasing",
  ENDT22 = "Named Driver",
  ENDT23 = "NCD Allowed",
  ENDT24 = "NCD Amendment",
  ENDT25 = "NCD Withdraw",
  ENDT29 = "Reinstatement of Extra Coverage",
  ENDT30 = "Revision of Sum Insured",
  ENDT34 = "Change of Make & Model",
  ENDT175 = "Amendment of e-Invoice Details",
  ENDT176 = "Change of e-Invoice Consent",
}
